import React, { useState, useEffect } from "react";
import { Loader } from "semantic-ui-react";
import { size, map } from "lodash";
import { Syllabu } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { SubjectGradeItem } from "../SubjectGradeItem";

const syllabuController = new Syllabu();

export function ListSubjectGrade(props) {
  const { grade, syllabuId, reload, onReload } = props;
  const [subjectGrades, setSubjectGrades] = useState(null);
  const { accessToken } = useAuth();

  useEffect(() => {
    (async () => {
      try {
        setSubjectGrades(null);
        const response = (grade.id) ? await syllabuController.getSyllabuSubjectGrades(accessToken, syllabuId, grade.id) : null;
        setSubjectGrades(response.assignedSubjects);
      } catch (error) {
        console.error(error);
      }
    })();
  }, [grade, syllabuId, reload, accessToken]);

  if (!subjectGrades) return <Loader active inline="centered" />;
  if (size(subjectGrades) === 0) return "No existen asignaturas en grado seleccionado";

  return map(subjectGrades, (subjectGrade) => (
    <SubjectGradeItem key={subjectGrade.id} subjectGrade={subjectGrade} onReload={onReload} />
  ));
}
